import { BannerId } from '../../../typings/banners';
import { InternalResourceId } from '../../../typings/internalBanners';

export const ADD_INTERNAL_BANNER_IMAGE = 'ADD_INTERNAL_BANNER_IMAGE';
export type ADD_INTERNAL_BANNER_IMAGE = typeof ADD_INTERNAL_BANNER_IMAGE;
export interface AddInternalBannerImage {
    type: ADD_INTERNAL_BANNER_IMAGE;
    bannerId: BannerId;
    resourceId: InternalResourceId;
}

export function addInternalBannerImageAction(
    bannerId: BannerId,
    resourceId: InternalResourceId
): AddInternalBannerImage {
    return {
        type: ADD_INTERNAL_BANNER_IMAGE,
        bannerId,
        resourceId
    };
}
